import useCheckPC from "@repo/hooks/utils/useCheckPC";
import classNames from "classnames";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import useMeta from "@hooks/reducerHooks/useMeta";

function PrivacyPolicy() {
  const { isPC } = useCheckPC();
  const { setMetaTag } = useMeta();

  const { t } = useTranslation();

  useEffect(() => {
    setMetaTag({ title: `TUNE.KR - PRIVACY POLICY` });
  }, []);

  return (
    <section className="tune-column-4 leading-relax">
      <div className={classNames("grid grid-cols-1 gap-x-5", isPC && "col-span-6 col-start-4 max-w-2xl")}>
        <div className="flex flex-col gap-[20px]">
          <span>{t("pages.privacy_policy.title")}</span>
          <div>
            <p className="whitespace-pre-line">{t("pages.privacy_policy.description")}</p>
          </div>
          <div>
            <p className="pb-2.5">
              <strong>{t("pages.privacy_policy.collected_personal_information_and_ways_of_collection.title")}</strong>
            </p>
            <ul className="list-outside list-decimal pl-4 font-regular">
              <li>
                {t(
                  "pages.privacy_policy.collected_personal_information_and_ways_of_collection.collected_personal_information.title",
                )}
                <ul className="list-outside list-disc pl-4">
                  <li>
                    {t(
                      "pages.privacy_policy.collected_personal_information_and_ways_of_collection.collected_personal_information.information1",
                    )}
                  </li>
                  <li>
                    {t(
                      "pages.privacy_policy.collected_personal_information_and_ways_of_collection.collected_personal_information.information2",
                    )}
                  </li>
                  <li>
                    {t(
                      "pages.privacy_policy.collected_personal_information_and_ways_of_collection.collected_personal_information.information3",
                    )}
                  </li>
                  <li>
                    {t(
                      "pages.privacy_policy.collected_personal_information_and_ways_of_collection.collected_personal_information.information4",
                    )}
                  </li>
                </ul>
              </li>
              <li>
                {t(
                  "pages.privacy_policy.collected_personal_information_and_ways_of_collection.ways_of_collection.title",
                )}
                <ul className="list-outside list-disc pl-4">
                  <li>
                    {t(
                      "pages.privacy_policy.collected_personal_information_and_ways_of_collection.ways_of_collection.information",
                    )}
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          <div>
            <p className="pb-2.5">
              <strong>{t("pages.privacy_policy.personal_information_agreement.title")}</strong>
            </p>
            <p>{t("pages.privacy_policy.personal_information_agreement.description")}</p>
            <ul className="list-outside list-disc pl-4 font-regular">
              <li>{t("pages.privacy_policy.personal_information_agreement.information1")}</li>
              <li>{t("pages.privacy_policy.personal_information_agreement.information2")}</li>
              <li>{t("pages.privacy_policy.personal_information_agreement.information3")}</li>
            </ul>
          </div>
          <div>
            <p className="pb-2.5">
              <strong>{t("pages.privacy_policy.retention_and_use_period_of_personal_information.title")}</strong>
            </p>
            <p>{t("pages.privacy_policy.retention_and_use_period_of_personal_information.description")}</p>
            <ul className="list-outside list-decimal pl-4 font-regular">
              <li>{t("pages.privacy_policy.retention_and_use_period_of_personal_information.information1")}</li>
              <li>
                {t("pages.privacy_policy.retention_and_use_period_of_personal_information.information2")}
                <ul className="list-outside list-none pt-1">
                  <li>
                    {t(
                      "pages.privacy_policy.retention_and_use_period_of_personal_information.records.contracts_or_withdrawal.title",
                    )}
                    <ul className="list-outside list-disc pb-1 pl-4">
                      <li>
                        {t(
                          "pages.privacy_policy.retention_and_use_period_of_personal_information.records.contracts_or_withdrawal.reason",
                        )}
                      </li>
                      <li>
                        {t(
                          "pages.privacy_policy.retention_and_use_period_of_personal_information.records.contracts_or_withdrawal.period",
                        )}
                      </li>
                    </ul>
                  </li>
                  <li>
                    {t(
                      "pages.privacy_policy.retention_and_use_period_of_personal_information.records.payment_and_supply.title",
                    )}
                    <ul className="list-outside list-disc pb-1 pl-4">
                      <li>
                        {t(
                          "pages.privacy_policy.retention_and_use_period_of_personal_information.records.payment_and_supply.reason",
                        )}
                      </li>
                      <li>
                        {t(
                          "pages.privacy_policy.retention_and_use_period_of_personal_information.records.payment_and_supply.period",
                        )}
                      </li>
                    </ul>
                  </li>
                  <li>
                    {t(
                      "pages.privacy_policy.retention_and_use_period_of_personal_information.records.complaints_or_dispute.title",
                    )}
                    <ul className="list-outside list-disc pb-1 pl-4">
                      <li>
                        {t(
                          "pages.privacy_policy.retention_and_use_period_of_personal_information.records.complaints_or_dispute.reason",
                        )}
                      </li>
                      <li>
                        {t(
                          "pages.privacy_policy.retention_and_use_period_of_personal_information.records.complaints_or_dispute.period",
                        )}
                      </li>
                    </ul>
                  </li>
                  <li>
                    {t("pages.privacy_policy.retention_and_use_period_of_personal_information.records.log.title")}
                    <ul className="list-outside list-disc pl-4">
                      <li>
                        {t("pages.privacy_policy.retention_and_use_period_of_personal_information.records.log.reason")}
                      </li>
                      <li>
                        {t("pages.privacy_policy.retention_and_use_period_of_personal_information.records.log.period")}
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          <div>
            <p className="pb-2.5">
              <strong>{t("pages.privacy_policy.destroying_personal_information.title")}</strong>
            </p>
            <p>{t("pages.privacy_policy.destroying_personal_information.description")}</p>
            <ul className="list-outside list-disc pl-4 font-regular">
              <li>{t("pages.privacy_policy.destroying_personal_information.information1")}</li>
              <li>{t("pages.privacy_policy.destroying_personal_information.information2")}</li>
            </ul>
          </div>
          <div>
            <p className="pb-2.5">
              <strong>{t("pages.privacy_policy.provision_personal_information.title")}</strong>
            </p>
            <p>{t("pages.privacy_policy.provision_personal_information.description")}</p>
            <ul className="list-outside list-disc pl-4 font-regular">
              <li>{t("pages.privacy_policy.provision_personal_information.information1")}</li>
              <li>{t("pages.privacy_policy.provision_personal_information.information2")}</li>
            </ul>
          </div>
          <div>
            <p className="pb-2">
              <strong>{t("pages.privacy_policy.consignment_of_personal_information.title")}</strong>
            </p>
            <p>{t("pages.privacy_policy.consignment_of_personal_information.description")}</p>
            <ul className="list-outside list-disc pl-4 font-regular">
              <li>{t("pages.privacy_policy.consignment_of_personal_information.consignee1")}</li>
              <li>{t("pages.privacy_policy.consignment_of_personal_information.details1")}</li>
              <li>{t("pages.privacy_policy.consignment_of_personal_information.consignee2")}</li>
              <li>{t("pages.privacy_policy.consignment_of_personal_information.details2")}</li>
              <li>{t("pages.privacy_policy.consignment_of_personal_information.consignee3")}</li>
              <li>{t("pages.privacy_policy.consignment_of_personal_information.details3")}</li>
              <li>{t("pages.privacy_policy.consignment_of_personal_information.consignee4")}</li>
              <li>{t("pages.privacy_policy.consignment_of_personal_information.details4")}</li>
            </ul>
          </div>
          <div>
            <p className="pb-2">
              <strong>{t("pages.privacy_policy.rights_of_customer_and_legal_representative.title")}</strong>
            </p>
            <ul className="list-outside list-disc pl-4 font-regular">
              <li>{t("pages.privacy_policy.rights_of_customer_and_legal_representative.information1")}</li>
              <li>{t("pages.privacy_policy.rights_of_customer_and_legal_representative.information2")}</li>
              <li>{t("pages.privacy_policy.rights_of_customer_and_legal_representative.information3")}</li>
              <li>{t("pages.privacy_policy.rights_of_customer_and_legal_representative.information4")}</li>
              <li>{t("pages.privacy_policy.rights_of_customer_and_legal_representative.information5")}</li>
            </ul>
          </div>
          <div>
            <p className="pb-2">
              <strong>{t("pages.privacy_policy.installation_operation_and_rejection.title")}</strong>
            </p>
            <p>{t("pages.privacy_policy.installation_operation_and_rejection.description")}</p>
            <ul className="list-outside list-none pt-1 font-regular">
              <li>
                {t("pages.privacy_policy.installation_operation_and_rejection.purpose.title")}
                <ul className="list-outside list-decimal pb-1 pl-4">
                  <li>{t("pages.privacy_policy.installation_operation_and_rejection.purpose.information1")}</li>
                  <li>{t("pages.privacy_policy.installation_operation_and_rejection.purpose.information2")}</li>
                </ul>
              </li>
              <li>
                {t("pages.privacy_policy.installation_operation_and_rejection.refuse_method.title")}
                <ul className="list-outside list-decimal pl-4">
                  <li>{t("pages.privacy_policy.installation_operation_and_rejection.refuse_method.information1")}</li>
                  <li>{t("pages.privacy_policy.installation_operation_and_rejection.refuse_method.information2")}</li>
                  <li>{t("pages.privacy_policy.installation_operation_and_rejection.refuse_method.information3")}</li>
                </ul>
              </li>
            </ul>
          </div>
          <div>
            <p className="pb-2">
              <strong>{t("pages.privacy_policy.complaint_service.title")}</strong>
            </p>
            <p>{t("pages.privacy_policy.complaint_service.description")}</p>
            <ul className="list-outside list-none pt-1 font-regular">
              <li>
                {t("pages.privacy_policy.complaint_service.officer.title")}
                <ul className="list-outside list-disc pb-1 pl-4">
                  <li>{t("pages.privacy_policy.complaint_service.officer.name")}</li>
                  <li>{t("pages.privacy_policy.complaint_service.officer.affiliation")}</li>
                  <li>{t("pages.privacy_policy.complaint_service.officer.tel")}</li>
                  <li>{t("pages.privacy_policy.complaint_service.officer.email")}</li>
                </ul>
              </li>
              <li>{t("pages.privacy_policy.complaint_service.information1")}</li>
              <li>{t("pages.privacy_policy.complaint_service.information2")}</li>
              <li>
                <li>{t("pages.privacy_policy.complaint_service.agency.description")}</li>
                <ul className="list-outside list-disc pl-4">
                  <li>{t("pages.privacy_policy.complaint_service.agency.center")}</li>
                  <li>{t("pages.privacy_policy.complaint_service.agency.committee")}</li>
                  <li>{t("pages.privacy_policy.complaint_service.agency.prosecutors_office")}</li>
                  <li>{t("pages.privacy_policy.complaint_service.agency.police")}</li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export default PrivacyPolicy;
